import { Injectable } from '@angular/core';
import { ConfiguracoesProjeto, GenericHttpService, ParametrosService } from '../../../shared';
import { URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs';
import { FiltroConsumidorReceitaFederal } from '../../../shared/filter/filtro-consumidor-receita-federal';

@Injectable()
export class ConsumidorReceitaFederalService {

    public _urlBase: string;
    public configuracao: ConfiguracoesProjeto;

    constructor(private readonly genericHttpService: GenericHttpService<any>,
        private readonly parametrosService: ParametrosService) {}
    
    get urlBase() {
      this.configuracao = this.parametrosService.getConfiguracao();
      this._urlBase = this.configuracao.uri + 'registro-cidadao/';
      return this._urlBase;
    }

    validaSituacaoConsumidorReceitaFederal(filtro: FiltroConsumidorReceitaFederal): Observable<any> {

        let searchParams: URLSearchParams = new URLSearchParams();
          searchParams.append('Cpf', filtro.cpf);
          searchParams.append('dataNascimento', filtro.dataNascimento.toString());
          searchParams.append('nomeMae', filtro.nomeMae);
    
          return this.genericHttpService.getAny(this.urlBase + `validacao/`, searchParams);
      }
}


// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/shared/consumidor-receita-federal-service.ts